/**
 *  Webfontを非同期で読み込むjs（PageSpeed対策）
 *
 *  Web Font Loader
 *  https://github.com/typekit/webfontloader
 */

import WebFont from 'webfontloader';

const fontLoader = () => {
  WebFont.load({
    google: {
      families: [
        // 'Lato:400,700',
        'Oswald:300,400,700',
      ],
    },
    custom: {
      families: ['FontAwesome'],
      urls: ['https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css'],
    },
  });
};

export default fontLoader;



// WEBPACK FOOTER //
// ./src/scripts/common/fontLoader.js